var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.333.5C23.833.5 20.75 2.25 19 5 17.25 2.25 14.166.5 10.666.5c-5.5 0-10 4.5-10 10 0 9.917 18.334 20 18.334 20s18.333-10 18.333-20c0-5.5-4.5-10-10-10Z",
    fill: "currentColor"
  })));
};
export default SvgHeart;